import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import { DASHBOARD_WIDGET_SPACING } from '../../../../constants/dashboardWidgetSpacing'
import { getImgPath } from '../../../../utils/getImgPath'

const externalInvoicesSyncIllustration = getImgPath('/external-invoices-sync/banner-external-invoices-sync.svg')

export const ExternalInvoicesSyncBannerWrapper = styled.div`
  width: 100%;
  height: 104px;
  margin: ${DASHBOARD_WIDGET_SPACING / 2}px 0;
  padding: ${Spacing.S16} ${Spacing.S24};
  border-radius: ${BorderRadius.R12};
  position: relative;
  background-color: ${Color.Lavender100};
  background-image: url('${externalInvoicesSyncIllustration}');
  background-position: bottom right 110px;
  background-repeat: no-repeat;
  background-size: contain;
`

export const CloseIconWrapper = styled.div`
  position: absolute;
  top: ${Spacing.S8};
  right: ${Spacing.S8};
`
